var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm.isRouterAlive ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLogin,
      expression: "!isLogin"
    }],
    staticClass: "appLoading"
  }, [_c('m-loading', {
    ref: "mLoadingRef",
    on: {
      "result": _vm.mLoadingResult
    }
  })], 1), _vm.isLogin ? [_c('layout')] : _vm._e()] : _vm._e(), _c('m-coin-anim')], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };